import env from './env';
import { navigateTo } from './location';

/**
 * Navigates the user to maui's instant-checkout route for the given INSTANT
 * cart. Mirrors the redirect performed inside maui's
 * `submitInstantCartCheckoutAction` (`useRecurringCustomizeFlow`) so both paths
 * hit the same checkout entry with the same `cartSource=INSTANT` marker — maui
 * reads that marker via `useResolvedCheckoutCart` to pick the INSTANT slot from
 * the cart store on landing.
 *
 * Encapsulates the cross-app URL contract in a single file so a future maui
 * route change is a one-line update here.
 * @param {string} cartUuid - The uuid of the freshly-created INSTANT cart.
 */
export const openMauiInstantCheckout = (cartUuid) => {
  navigateTo(`${env.envURL}/confirm/checkout?cartUuid=${cartUuid}&cartSource=INSTANT`);
};

export default openMauiInstantCheckout;
